import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';

interface NavbarProps {
  scrolled: boolean;
}

const Navbar = ({ scrolled }: NavbarProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header 
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'
      }`}
    >
      <div className="container-custom">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <NavLink to="/" className="text-2xl font-bold">
              <span className={`${scrolled ? 'text-navy-900' : 'text-white'}`}>
                CV Samudera Alam Perkasa
              </span>
            </NavLink>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex space-x-8">
            {[
              { name: 'Beranda', path: '/' },
              { name: 'Tentang Kami', path: '/about' },
              { name: 'Layanan', path: '/services' },
              { name: 'Portofolio', path: '/portfolio' },
              { name: 'Tim Kami', path: '/team' },
              { name: 'Kontak', path: '/contact' },
            ].map((item) => (
              <NavLink
                key={item.name}
                to={item.path}
                className={({ isActive }) =>
                  `font-medium transition-colors duration-300 ${
                    isActive
                      ? 'text-primary-600'
                      : scrolled
                      ? 'text-gray-800 hover:text-primary-600'
                      : 'text-white hover:text-yellow-500'
                  }`
                }
              >
                {item.name}
              </NavLink>
            ))}
          </nav>
          
          <div className="hidden lg:block">
            <NavLink to="/contact" className="btn btn-primary">
              Hubungi Kami
            </NavLink>
          </div>
          
          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={toggleMenu}
              className={`p-2 rounded-md focus:outline-none ${
                scrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>
      
      {/* Mobile Menu */}
      <div
        className={`lg:hidden transition-all duration-300 ease-in-out ${
          isOpen
            ? 'max-h-screen opacity-100 visible bg-white shadow-md'
            : 'max-h-0 opacity-0 invisible'
        }`}
      >
        <div className="container-custom py-4 space-y-2">
          {[
            { name: 'Beranda', path: '/' },
            { name: 'Tentang Kami', path: '/about' },
            { name: 'Layanan', path: '/services' },
            { name: 'Portofolio', path: '/portfolio' },
            { name: 'Tim Kami', path: '/team' },
            { name: 'Kontak', path: '/contact' },
          ].map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              onClick={() => setIsOpen(false)}
              className={({ isActive }) =>
                `block py-2 font-medium ${
                  isActive ? 'text-primary-600' : 'text-gray-800 hover:text-primary-600'
                }`
              }
            >
              {item.name}
            </NavLink>
          ))}
          <div className="pt-2">
            <NavLink to="/contact" onClick={() => setIsOpen(false)} className="btn btn-primary">
              Hubungi Kami
            </NavLink>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;